import React from 'react';
import { CpgAuthorizationCallbackHandler, FormLayout } from '../../containers';

/**
 * Страница "Авторизация через ЦПГ".
 */
const CpgAuthorizationCallbackHandlerPage: React.FC = () => {
    return (
        <FormLayout>
            <CpgAuthorizationCallbackHandler />
        </FormLayout>
    );
};

/**
 * Название компонента, используемое при отладке.
 */
CpgAuthorizationCallbackHandlerPage.displayName = 'CpgAuthorizationCallbackHandlerPage';

export default CpgAuthorizationCallbackHandlerPage;
